
































import { PropType } from 'vue';
import { IAiStream } from '../types';
import { fmtTime, parseUtcMs } from '../utils';
import { COLOR_DETAIL_FALLBACK } from '../constants';
import LangChip from './LangChip.vue';

export default {
  name: 'CalendarClusterCard',
  components: { LangChip },
  props: {
    items: {
      type: Array as PropType<IAiStream[]>,
      required: true
    },
    color: { type: String, default: COLOR_DETAIL_FALLBACK },
    colorMap: {
      type: Object as PropType<Record<string, string>>,
      default: (): Record<string, string> => ({})
    },
    startTime: { type: String, default: '' },
    endTime: { type: String, default: '' },
    visibleRows: { type: Number, default: 0 },
    nowUtc: { type: String, default: '' }
  },
  computed: {
    isPast(): boolean {
      if (!this.endTime || !this.nowUtc) return false;
      return parseUtcMs(this.endTime) <= parseUtcMs(this.nowUtc);
    }
  },
  methods: {
    fmtTime
  }
};
